// Guardas para la recarga silenciosa post-deploy (compañero de
// src/composables/useVersionCheck.js — ver el guard y las redes de
// recuperación en main.js).

const CHUNK_ERROR_RE = /Loading (CSS )?chunk|ChunkLoadError/;
const RELOAD_CAP_PER_SESSION = 2;

// vue-router 3 solo entrega el error en router.onError (sin `to`), así que el
// guard registra aquí la última ruta intentada para poder recargar hacia ella.
let lastAttemptedRoute = null;
export function recordAttemptedRoute(fullPath) {
  lastAttemptedRoute = fullPath;
}
export function getAttemptedRoute() {
  return lastAttemptedRoute;
}

export function isChunkLoadError(err) {
  if (!err) return false;
  // webpack 4: name === 'ChunkLoadError'; mini-css-extract-plugin usa
  // code === 'CSS_CHUNK_LOAD_FAILED' con message "Loading CSS chunk N failed".
  if (err.code === "CSS_CHUNK_LOAD_FAILED" || err.name === "ChunkLoadError") {
    return true;
  }
  return CHUNK_ERROR_RE.test(String((err && err.message) || err));
}

// Solo rutas internas: history-mode sin `base` significa que un fullPath tipo
// '//evil.com/x' pasado a location.assign sería un open redirect.
export function safeInternalPath(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}

// Una recarga forzada por versión y máximo RELOAD_CAP_PER_SESSION por pestaña:
// aunque una edge cache siga sirviendo la build vieja tras recargar, jamás se
// entra en loop. Devuelve true si la recarga quedó en curso.
export function oneShotReload(versionKey, path) {
  if (!safeInternalPath(path)) return false;
  try {
    const key = `kl_reload_done:${versionKey || "unknown"}`;
    if (sessionStorage.getItem(key)) return false;
    const total = Number(sessionStorage.getItem("kl_reload_count") || "0");
    if (total >= RELOAD_CAP_PER_SESSION) return false;
    sessionStorage.setItem(key, "1");
    sessionStorage.setItem("kl_reload_count", String(total + 1));
  } catch (e) {
    // sessionStorage inaccesible: sin guardas no se recarga (fail-open)
    return false;
  }
  window.location.assign(window.location.origin + path);
  return true;
}
